module.exports = "<simple-crud service=\"assistants.Assistant\" translations=\"assistants.translations\"></simple-crud>"


//////////////////
// WEBPACK FOOTER
// ./client/app/manager/assistants/assistants.pug
// module id = 213
// module chunks = 0